// react redux store
import store from '../../redux/store';

const canSetupAlertsForOthersPermission = ({
  user = store.getState().auth.user,
} = {}) => user?.['custom:userRole'] === 'TenantAdmin';

export default canSetupAlertsForOthersPermission;
